// OPTION 1: Replace your existing media-gallery.js file with this corrected version
// Location: assets/media-gallery.js

if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.viewer.addEventListener("click", this._onClickFunc.bind(this));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      
      // Add mouse tracking for drag detection
      this.mouseDownX = 0;
      this.mouseDownY = 0;
      this.hasDragged = false;
      
      this.elements.viewer.addEventListener('mousedown', (e) => {
        this.mouseDownX = e.clientX;
        this.mouseDownY = e.clientY;
        this.hasDragged = false;
      });
      
      this.elements.viewer.addEventListener('mousemove', (e) => {
        if (this.mouseDownX === 0) return;
        const diffX = Math.abs(e.clientX - this.mouseDownX);
        const diffY = Math.abs(e.clientY - this.mouseDownY);
        if (diffX > 5 || diffY > 5) {
          this.hasDragged = true;
        }
      });
      
      this.elements.viewer.addEventListener('mouseup', () => {
        this.mouseDownX = 0;
        this.mouseDownY = 0;
      });
    }
    
    _onClickFunc(event) {
      // Don't navigate if user was dragging
      if (this.hasDragged) {
        this.hasDragged = false;
        return;
      }
      
      // Don't navigate if clicking on buttons or interactive elements
      if (event.target.closest('button') || event.target.closest('a')) {
        return;
      }
      
      const thumbnails = this.elements.thumbnails.querySelectorAll('[data-target]');
      const currentIndex = Array.from(thumbnails).findIndex(
        thumb => thumb.querySelector('button').getAttribute('aria-current') === 'true'
      );
      
      if (currentIndex === -1) return;
      
      let targetIndex;
      
      // Click on right half - go to next slide
      if (event.offsetX > this.elements.viewer.offsetWidth / 2) {
        targetIndex = currentIndex < thumbnails.length - 1 ? currentIndex + 1 : 0;
      } 
      // Click on left half - go to previous slide
      else {
        targetIndex = currentIndex > 0 ? currentIndex - 1 : thumbnails.length - 1;
      }
      
      const targetThumbnail = thumbnails[targetIndex];
      if (targetThumbnail) {
        this.setActiveMedia(targetThumbnail.dataset.target, false);
      }
    }
    
    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }
    
    setActiveMedia(mediaId, prepend) {      
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
    
  });
}

